import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useTranslation } from "../../contexts/TranslationContext";
import "../../assets/css/galleryFilter.scss";
import { processScannersByAgency } from "../../utils/scannerProcessing";
import MultiSelection from "../UC/MultiSelection";
import api from "../../utils/api";

const GalleryFilter = ({ galleryType, setGalleryType, applyFilters, isAnalyze,
  onFilterChange, showTopResult = false, selectionMode = false, className = "",
  onFilterReady, historyFilters
}) => {
  const { language } = useTranslation();
  const [showAdvanceFilters, setShowAdvanceFilters] = useState(false);
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);

  const [makes, setMakes] = useState([]);
  const [scanners, setScanners] = useState([]);
  const [selectedMakes, setSelectedMakes] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [selectedScanners, setSelectedScanners] = useState([]);
  const [formattedScanners, setFormattedScanners] = useState([]);

  const defaultFilterCatalog = {
    Make_IDs: [],
    ShoeTypes: [],
    Models: [],
    ProductCode: "",
  };

  const loginAccount = useMemo(() => {
    const stored = localStorage.getItem("FWUser");
    return stored ? JSON.parse(stored) : null;
  }, []);

  const defaultFilterEvidence = {
    Scanner_IDs: [loginAccount && loginAccount.Information ? `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}` : null].filter(id => id), // Set to current user scanner if available
    Category_IDs: [], // Default to both types for evidence
    CaseIncidents: [],
  };


  // Updated filters structure
  const [filters, setFilters] = useState({
    // Catalog filters
    Make_IDs: [],
    ShoeTypes: [],
    Models: [],
    ProductCode: "",
    SearchFilterMode: "like",
    // Evidence filters
    Scanner_IDs: [],
    Category_IDs: ["2", "3"], // Default to both types for evidence
    Agency_IDs: [],
    CaseIncidents: [],
    TopResult: 100 // Default value for top result
  });

  // useEffect(() => {
  //   if (galleryType === "catalog") {
  //     setFilters({
  //       Make_IDs: [],
  //       ShoeTypes: [],
  //       Models: [],
  //       ProductCode: "",
  //       SearchFilterMode: "like",
  //       TopResult: 100
  //     });
  //   } else if (galleryType === "evidence") {
  //     let loginAccount = JSON.parse(localStorage.getItem("FWUser"));
  //     let currentUserID = loginAccount && loginAccount.Information ? `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}` : null;
  //     setFilters({
  //       Scanner_IDs: [currentUserID].filter(id => id), // Set to current user scanner if available
  //       Category_IDs: ["2", "3"], // Default to both types for evidence
  //       CaseIncidents: [],
  //       SearchFilterMode: "like",
  //     });
  //   }
  // }, [galleryType]);


  const [inputCaseIncidents, setInputCaseIncidents] = useState("");
  const [inputShoeType, setInputShoeType] = useState("");
  const [inputModels, setInputModels] = useState("");

  // useEffect(() => {
  //   if (galleryType === 'evidence') {
  //     // default select scanner based on login account
  //     if (loginAccount && formattedScanners.length > 0) {
  //       let loginAccountMatchID = `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`;
  //       const defaultScanner = formattedScanners.find(scanner =>
  //         scanner.ID === loginAccountMatchID
  //       );

  //       if (defaultScanner) {
  //         setSelectedScanners([defaultScanner]);
  //         setFilters(prevFilters => ({
  //           ...prevFilters,
  //           Scanner_IDs: [defaultScanner.ID]
  //         }));
  //       }
  //     }
  //   }
  // }, [galleryType, formattedScanners, loginAccount]);

  useEffect(() => {

    if (onFilterChange) {
      onFilterChange(filters);
    }
  }, [filters, onFilterChange]);

  // Load filters from history data when historyFilters prop changes
  useEffect(() => {
    if (!historyFilters || galleryType !== "catalog" || makes.length === 0) return;

    // Extract Make_IDs and find corresponding make objects
    let arrMake_IDs = makes.filter(make =>
      // find makes in historyFilters.Makes in lower case for case insensitive match
      historyFilters.Makes.map(name => name.toLowerCase()).includes(make.Value.toLowerCase())
    );

    setSelectedMakes(arrMake_IDs);

    // Update filters state with history data
    setFilters(prevFilters => ({
      ...prevFilters,
      Make_IDs: historyFilters.Make_IDs || [],
      ShoeTypes: historyFilters.ShoeTypes || [],
      Models: historyFilters.Models || [],
      ProductCode: historyFilters.ProductCode || "",
      TopResult: historyFilters.CandidateSize || prevFilters.TopResult
    }));

    setInputShoeType(historyFilters.ShoeTypes ? historyFilters.ShoeTypes.join(", ") : "");
    setInputModels(historyFilters.Models ? historyFilters.Models.join(", ") : "");

  }, [historyFilters, galleryType, makes]);

  // Load Makes from localStorage when needed (for catalog)
  useEffect(
    () => {


      if (galleryType === "catalog") {
        // const storedMakes = localStorage.getItem("list_makes");
        // if (storedMakes) {
        //   setMakes(JSON.parse(storedMakes));
        //   // Notify parent that filter is ready (immediate for cached data)
        //   if (onFilterReady) {
        //     setTimeout(() => onFilterReady(true), 0);
        //   }
        // } else
           //{
          const fetchMakesFromAPI = async () => {
            try {
              setIsLoadingFilters(true);
              if (onFilterReady) onFilterReady(false);

              const _tokenRequestAPI = localStorage.getItem("FWToken");
              const response = await api.post(
                `${global.config.api.domain}/fwiq-api/api/catalog/getpartialfilters`,
                { Token: _tokenRequestAPI, Fields: ["make"] }
              );

              if (response.status === 200 || response.status === 204) {
                let data = response.data;
                // Safety: if response.data is still a string (parser failed), try JSON.parse
                if (typeof data === 'string') {
                  try { data = JSON.parse(data); } catch { data = {}; }
                }
                data = data || {};
                if (data.Makes) {
                  setMakes(data.Makes);
                  localStorage.setItem("filters", JSON.stringify(data));
                }
              } else {
                console.error("Failed to fetch makes from API");
              }
            } catch (error) {
              console.error("Error fetching makes:", error);
            } finally {
              setIsLoadingFilters(false);
              if (onFilterReady) {
                setTimeout(() => onFilterReady(true), 0);
              }
            }
          };
          fetchMakesFromAPI();
        //}
      }
      else {
        let storedScanners = '';// localStorage.getItem("list_scanners");
        if (storedScanners) {
          storedScanners = JSON.parse(storedScanners);
          setScanners(storedScanners);

          // Process scanners to extract agencies
          const { agencies: extractedAgencies, formattedScanners } = processScannersByAgency(storedScanners);

          // Set default scanner selection based on login account
          if (loginAccount) {
            let loginAccountMatchID = `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`;

            const defaultScanner = formattedScanners.find(scanner =>
              scanner.ID === loginAccountMatchID
            );


            if (defaultScanner) {
              setSelectedScanners([defaultScanner]);
              
              // Check if loginAccount is a customer and set Agency_IDs accordingly
              const agencyIDs = [];
              if (loginAccount.Information.AgencyType && 
                  loginAccount.Information.AgencyType.toLowerCase() === "customer") {
                  agencyIDs.push(loginAccount.Information.User_ID);
              }
              
              setFilters(prevFilters => ({
                ...prevFilters,
                Scanner_IDs: [defaultScanner.ID],
                Agency_IDs: agencyIDs
              }));

            }
            else {
              // default add current login account to formattedScanners and extractedAgencies
              if (loginAccount && loginAccount.Information) {
                const newScanner = {
                  ID: `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`,
                  Value: `${loginAccount.Information.Name}`,
                }

                // Add to agencies if not already present
                if (!extractedAgencies.find(a => a.ID === loginAccount.Information.User_ID)) {
                  extractedAgencies.push({
                    ID: loginAccount.Information.User_ID,
                    Name: loginAccount.Information.AgencyName || loginAccount.Information.User_ID
                  });

                  formattedScanners.push({
                    ID: newScanner.ID,
                    Value: newScanner.Value,
                    GroupID: loginAccount.Information.User_ID
                  });
                } else {
                  // Just add the scanner if agency exists
                  formattedScanners.push({
                    ID: newScanner.ID,
                    Value: newScanner.Value,
                    GroupID: loginAccount.Information.User_ID
                  });

                  // Check if loginAccount is a customer and set Agency_IDs accordingly
                  const agencyIDs = [];
                  if (loginAccount.Information.AgencyType && 
                      loginAccount.Information.AgencyType.toLowerCase() === "customer") {
                      agencyIDs.push(loginAccount.Information.User_ID);
                  }
                  
                  // Set as default selected scanner
                  setSelectedScanners([{
                    ID: newScanner.ID,
                    Value: newScanner.Value,
                    GroupID: loginAccount.Information.User_ID
                  }]);
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    Scanner_IDs: [newScanner.ID],
                    Agency_IDs: agencyIDs
                  }));
                }
              }
            }


            if (onFilterReady) {
              setTimeout(() => onFilterReady(true), 0);
            }
          }

          setAgencies(extractedAgencies);
          setFormattedScanners(formattedScanners);

        } else {
          const fetchScannersFromAPI = async () => {
            try {
              setIsLoadingFilters(true);

              if (onFilterReady)
                onFilterReady(false);

              const _tokenEvidence = localStorage.getItem("FWToken");
              const response = await api.post(
                `${global.config.api.domain}/fwiq-api/api/evidence/getpartialfilters`,
                { Token: _tokenEvidence, Fields: ["agency", "scanner"] }
              );

              if (response.status === 200 || response.status === 204) {
                let data = response.data;
                // Safety: if response.data is still a string (parser failed), try JSON.parse
                if (typeof data === 'string') {
                  try { data = JSON.parse(data); } catch { data = {}; }
                }
                data = data || {};
                if (!data.Scanners) {
                  if (onFilterReady) setTimeout(() => onFilterReady(true), 0);
                  return;
                }
                setScanners(data.Scanners);
                localStorage.setItem("list_scanners", JSON.stringify(data.Scanners));

                // Process scanners to extract agencies
                const { agencies: extractedAgencies, formattedScanners } = processScannersByAgency(data.Scanners, data.Agencies);


                // Set default scanner selection based on login account
                if (loginAccount) {
                  let loginAccountMatchID = `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`;

                  const defaultScanner = formattedScanners.find(scanner =>
                    scanner.ID === loginAccountMatchID
                  );

                  if (defaultScanner) {
                    setSelectedScanners([defaultScanner]);
                    
                    // Check if loginAccount is a customer and set Agency_IDs accordingly
                    const agencyIDs = [];
                    if (loginAccount.Information.AgencyType && 
                        loginAccount.Information.AgencyType.toLowerCase() === "customer") {
                        agencyIDs.push(loginAccount.Information.User_ID);
                    }
                    
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      Scanner_IDs: [defaultScanner.ID],
                      Agency_IDs: agencyIDs
                    }));
                  }
                  else {
                    // default add current login account to formattedScanners and extractedAgencies
                    if (loginAccount && loginAccount.Information) {
                      const newScanner = {
                        ID: `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`,
                        Value: `${loginAccount.Information.Name}`,
                      }
                      
                      // Add to agencies if not already present
                      if (!extractedAgencies.find(a => a.ID === loginAccount.Information.User_ID)) {
                        extractedAgencies.push({
                          ID: loginAccount.Information.User_ID,
                          Name: loginAccount.Information.AgencyName || loginAccount.Information.User_ID
                        });

                        formattedScanners.push({
                          ID: newScanner.ID,
                          Value: newScanner.Value,
                          GroupID: loginAccount.Information.User_ID
                        });
                      }
                      else {
                        // Just add the scanner if agency exists
                        formattedScanners.push({
                          ID: newScanner.ID,
                          Value: newScanner.Value,
                          GroupID: loginAccount.Information.User_ID
                        });
                        
                        // Check if loginAccount is a customer and set Agency_IDs accordingly
                        const agencyIDs = [];
                        if (loginAccount.Information.AgencyType && 
                            loginAccount.Information.AgencyType.toLowerCase() === "customer") {
                            agencyIDs.push(loginAccount.Information.User_ID);
                        }
                        
                        // Set as default selected scanner
                        setSelectedScanners([{
                          ID: newScanner.ID,
                          Value: newScanner.Value,
                          GroupID: loginAccount.Information.User_ID
                        }]);
                        setFilters(prevFilters => ({
                          ...prevFilters,
                          Scanner_IDs: [newScanner.ID],
                          Agency_IDs: agencyIDs
                        }));
                      }
                    }
                  }


                  if (onFilterReady) {
                    setTimeout(() => onFilterReady(true), 0);
                  }
                }

                setAgencies(extractedAgencies);
                setFormattedScanners(formattedScanners);

              } else {
                console.error("Failed to fetch scanners from API");
                if (onFilterReady) {
                  onFilterReady(false);
                }
              }
            } catch (error) {
              console.error("Error fetching scanners:", error);
              if (onFilterReady) {
                onFilterReady(false);
              }
            } finally {
              setIsLoadingFilters(false);
            }
          };
          fetchScannersFromAPI();
        }
      }
    },
    [galleryType]
  );

  // Reset filters function
  const resetFilters = useCallback(() => {
    setSelectedMakes([]);
    setSelectedScanners([]); // Set to default scanner based on login account

    if (galleryType === "catalog") {
      setFilters({
        Make_IDs: [],
        ShoeTypes: [],
        Models: [],
        ProductCode: "",
        SearchFilterMode: "like",
        TopResult: 100
      });
    } else if (galleryType === "evidence") {
      let loginAccount = JSON.parse(localStorage.getItem("FWUser"));
      let currentUserID = loginAccount && loginAccount.Information ? `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}` : null;
      setFilters({
        Scanner_IDs: [currentUserID].filter(id => id), // Set to current user scanner if available
        Category_IDs: ["2", "3"], // Default to both types for evidence
        Agency_IDs: [],
        CaseIncidents: [],
        SearchFilterMode: "like",
      });
    }
  }, [galleryType]);

  // Reset filters when gallery type changes
  useEffect(
    () => {
      resetFilters();
    },
    [galleryType, resetFilters]
  ); const handleMakeChange = selectedOptions => {
    setSelectedMakes(selectedOptions);

    setFilters(prevFilters => ({
      ...prevFilters,
      Make_IDs: selectedOptions.map(option => option.ID)
    }));
  };

  // Handle scanner selection changes
  const handleScannerChange = selectedOptions => {
    
    setSelectedScanners(selectedOptions);

    setFilters(prevFilters => ({
      ...prevFilters,
      Scanner_IDs: selectedOptions.map(option => option.ID)
    }));
  };

  const handleApplyFilters = () => {

    let formattedFilters = {};



    if (galleryType === "catalog") {
      formattedFilters = {
        Make_IDs: filters.Make_IDs,
        ShoeTypes: filters.ShoeTypes,
        Models: filters.Models,
        ProductCode: filters.ProductCode,
        SearchFilterMode: "like"
      };

    } else if (galleryType === "evidence") {
      formattedFilters = {
        CaseIncidents: filters.CaseIncidents,
        Category_IDs: filters.Category_IDs,
        Scanner_IDs: filters.Scanner_IDs,
        Agency_IDs: filters.Agency_IDs,
        SearchFilterMode: "like"
      };

      // if(filters.CaseIncidents === "")
      //   formattedFilters.CaseIncidents = [];
    }

    // console.log("Formatted filters for API:", formattedFilters);

    // Call the applyFilters function passed from Gallery.jsx
    applyFilters(formattedFilters);

  };

  const caseIncidentChange = (value) => {
    // Split by comma, semicolon, and line breaks, then clean up
    setInputCaseIncidents(value);
    const caseIncidents = value.split(/[\n,;]+/).map(item => item.trim()).filter(item => item);
    setFilters(prevFilters => ({
      ...prevFilters,
      CaseIncidents: caseIncidents
    }));
  };

  const shoeTypeChange = (value) => {
    setInputShoeType(value);
    const shoeTypesArray = value.split(/[,;]/).map(item => item.trim()).filter(item => item);
    setFilters(prevFilters => ({ ...prevFilters, ShoeTypes: shoeTypesArray }));
  };

  const modelsChange = (value) => {
    setInputModels(value);
    const modelsArray = value.split(/[,;]/).map(item => item.trim()).filter(item => item);
    setFilters(prevFilters => ({ ...prevFilters, Models: modelsArray }));
  }

  return (
    <div className={`galleryFilter${isAnalyze ? " isAnalyze" : ""}${selectionMode ? " selectionMode" : ""}${className ? ` ${className}` : ""}`}>
      <div
        style={{ display: "none" }}
        className="select-type"
      >
        <div
          data-type="catalog"
          className={`data-type ${galleryType === "catalog" ? "selected" : ""}`}
          onClick={() => setGalleryType("catalog")}
        >
          <div>
            <h4>{language.galleryFilter?.footwearCatalog || "Footwear Catalog"}</h4>
          </div>
        </div>
        <div
          data-type="evidence"
          className={`data-type ${galleryType === "evidence"
            ? "selected"
            : ""}`}
          onClick={() => setGalleryType("evidence")}
        >
          <div>
            <h4>{language.galleryFilter?.impressionRecords || "Impression Records"}</h4>
          </div>
        </div>
      </div>

      {/* Catalog-specific filters */}
      {galleryType === "catalog" &&
        <div className="filters" data-type="catalog">
          <div className="a-filter">
            <div className="filter-title">{language.galleryFilter?.make || "Make"}</div>
            <div className="filter-data">
              <MultiSelection
                options={makes}
                placeholder={language.galleryFilter?.selectMake || "Select Make"}
                onChange={handleMakeChange}
                defaultSelected={selectedMakes}
              />
            </div>
          </div>
          <div className="a-filter">
            <div className="filter-title">{language.galleryFilter?.type || "Type"}</div>
            <div className="filter-data">
              <input
                type="text"
                name="ShoeTypes"
                value={inputShoeType}
                onChange={e => {
                  shoeTypeChange(e.target.value);
                }}
                placeholder={language.galleryFilter?.enterShoeType || "Enter shoe type(s), separated by commas or semicolons"}
              />
            </div>
          </div>
          <div className="a-filter">
            <div className="filter-title">{language.galleryFilter?.model || "Model"}</div>
            <div className="filter-data">
              <input
                type="text"
                name="Models"
                value={inputModels}
                onChange={e => {
                  modelsChange(e.target.value);
                }}
                placeholder={language.galleryFilter?.enterModel || "Enter model(s), separated by commas or semicolons"}
              />
            </div>
          </div>
          <div className="a-filter">
            <div className="filter-title">{language.galleryFilter?.productId || "Product ID"}</div>
            <div className="filter-data">
              <input
                type="text"
                id="txtProductCode_Catalog"
                value={filters.ProductCode}
                onChange={e =>
                  setFilters(prevFilters => ({ ...prevFilters, ProductCode: e.target.value }))}
                placeholder={language.galleryFilter?.enterProductId || "Enter product ID"}
              />
            </div>
          </div>
          {showTopResult && (
            <div className="a-filter">
              <div className="filter-title">{language.galleryFilter?.topResult || "Top Result"}</div>
              <div className="filter-data">
                <input
                  type="number"
                  id="txtTopResult"
                  value={filters.TopResult}
                  onChange={e =>
                    setFilters(prevFilters => ({ ...prevFilters, TopResult: parseInt(e.target.value) || 100 }))}
                  placeholder="100"
                  min="1"
                  max="500"
                />
              </div>
            </div>
          )}
        </div>
      }

      {/* Evidence-specific filters */}
      {galleryType === "evidence" &&
        <div className="filters" data-type="evidence">
          {/* Add Scanner Selection with Grouping */}
          <div className="a-filter">
            <div className="filter-title">{language.galleryFilter?.importedBy || "Imported By"}</div>
            <div className="filter-data">
              <MultiSelection
                options={processScannersByAgency(scanners, agencies).formattedScanners}
                groups={agencies}
                enableGroups={true}
                placeholder={language.galleryFilter?.selectScanners || "Select Scanners"}
                onChange={handleScannerChange}
                enableSearch={true}
                defaultSelected={selectedScanners}
              />
            </div>
          </div>

          {/* Existing Data Type filter */}
          <div className="a-filter">
            <div className="filter-title">{language.galleryFilter?.dataType || "Data Type"}</div>
            <div className="filter-data checkbox-group">
              <label>
                <input
                  type="checkbox"
                  value="2"
                  checked={filters?.Category_IDs?.includes("2")}
                  onChange={e => {
                    const value = e.target.value;
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      Category_IDs: e.target.checked
                        ? [...(prevFilters.Category_IDs || []), value]
                        : (prevFilters.Category_IDs || []).filter(type => type !== value)
                    }));
                  }}
                />
                {language.galleryFilter?.recoveredImpression || "Recovered Impression (RS)"}
              </label>
              <label>
                <input
                  type="checkbox"
                  value="3"
                  checked={filters?.Category_IDs?.includes("3")}
                  onChange={e => {
                    const value = e.target.value;
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      Category_IDs: e.target.checked
                        ? [...(prevFilters.Category_IDs || []), value]
                        : (prevFilters.Category_IDs || []).filter(type => type !== value)
                    }));
                  }}
                />
                {language.galleryFilter?.testShoe || "Test Shoe (TS)"}
              </label>
            </div>
          </div>
          <div className="a-filter">
            <div className="filter-title">{language.galleryFilter?.caseIncident || "Case/Incident #"}</div>
            <div className="filter-data">
              <textarea
                style={{ height: "4rem" }}
                value={inputCaseIncidents}
                onChange={e => caseIncidentChange(e.target.value)}
                placeholder={language.galleryFilter?.enterCaseNumber || "Enter case incident(s), separated by commas, semicolons, or line breaks"}
              />
            </div>
          </div>
        </div>
      }

      {/* Common filter actions */}

      {!isAnalyze && (
        <div className="filter-actions">
          <button className="apply-filters-btn" onClick={handleApplyFilters}>
            <i className="fa fa-filter" />
            {language.galleryFilter?.applyFilters || "Apply Filters"}
          </button>
        </div>
      )}

    </div>
  );
};

export default GalleryFilter;
